import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { modalState, toggleModal, detailOpenState } from 'reducers/ui';

import LayoutWithMap from 'containers/Base/LayoutWithMap';
import { getUserAssignedDepartmentList } from 'reducers/users';

import useFilters from 'containers/Base/useFilters.js';
import { filters } from '../filters';

import { nameSpace } from '../Modules/nameSpace';
import { actions as customerActions } from '../Modules/dataGridTable';
import { actions as customerClientFilterActions } from '../Modules/filters';
import * as customerSelectors from '../Selectors/customerSelector';
import { getSecurityCompanyId } from 'reducers/securityCompany';
import { PAGE_URLS } from 'utils/constants';

const Customer = ({
  columns,
  filtersRequired,
  FormComponent,
  editable,
  details,
  loading,
}) => {
  //---------------------------Selectors---------------------------
  const customerListData = useSelector(state =>
    customerSelectors.getCustomerListTransformed(state),
  );
  const detailOpen = useSelector(state => detailOpenState(state));
  const totalEntries = useSelector(state =>
    customerSelectors.getTotalRowsCount(state),
  );
  const filterValues = useSelector(state =>
    customerSelectors.getCustomerFilters(state),
  );
  const forceRefresh = useSelector(state =>
    customerSelectors.getForceRefresh(state),
  );
  const securityCompanyId = useSelector(state => getSecurityCompanyId(state));
  const modalOpen = useSelector(state => modalState(state));

  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();

  const dispatchFetchCustomerList = useCallback(
    ({ filters, from }) =>
      dispatch(customerActions.fetchGridList({ filters, from })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );

  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(nameSpace)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );
  //----------------------------------------------------------------
  const onUpdate = filters => {
    dispatchFetchCustomerList({
      filters,
    });
  };
  const fetchCustomers = from => {
    dispatchFetchCustomerList({
      filters: localFilterValues,
      from,
    });
  };
  const CustomerFormComponent = useCallback(
    props => (
      <FormComponent
        {...props}
        userAssignedDepartments={userAssignedDepartments}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return (
    <LayoutWithMap
      header="Connect Users"
      cols={columns}
      data={customerListData}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      //details
      DetailComponent={details}
      //creating and editing
      editable={editable}
      FormComponent={CustomerFormComponent}
      toggleModal={dispatchToggleModal}
      onEdit={modalOpen[nameSpace]}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={filters({ userAssignedDepartments, securityCompanyId })}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            customerClientFilterActions.setFilterKey({ key: true });
            customerClientFilterActions.setFilters({ filters });
          },
        })
      }
      //end-filters
      onUpdate={onUpdate}
      fetchData={fetchCustomers}
      forceOpenDetailPanel={detailOpen[PAGE_URLS.CUSTOMERS.link]}
      persistentStateName={PAGE_URLS.CUSTOMERS.name}
    />
  );
};

Customer.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
  userAssignedDepartments: PropTypes.array,
};
export default Customer;
